import camelize from 'camelize';
import urlJoin from 'url-join';


export const GEO_DATA_REQUEST = 'GEO_DATA_REQUEST';
export const GEO_DATA_SUCCESS = 'GEO_DATA_SUCCESS';
export const GEO_DATA_FAILURE = 'GEO_DATA_FAILURE';

const getGeoDataRequest = (payload) => ({
  type: GEO_DATA_REQUEST,
  payload,
});

const getGeoDataSuccess = (payload) => ({
  type: GEO_DATA_SUCCESS,
  payload,
});

const getGeoDataFailure = (error) => ({
  type: GEO_DATA_FAILURE,
  error,
});

export const getGeoData = (dataset) => (dispatch, getState) => {
  dispatch(getGeoDataRequest({ dataset }));
  const url = urlJoin(window.BASE_PATH || '/', 'geo', `${dataset}.json`);

  fetch(url, { credentials: 'include' })
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then(response => response.json())
    .then(data => camelize(data))
    .then(data => dispatch(getGeoDataSuccess({ dataset, data })))
    .catch(err => {
      dispatch(getGeoDataFailure(err));
      console.log(err);
    });
};



// WEBPACK FOOTER //
// ./src/actions/geoDataActions.js